export const isDevelopment = import.meta.env.DEV;
export const isStaging = import.meta.env.VITE_API_URL.includes('staging');
